// extracted by mini-css-extract-plugin
export default {"how":"Embsample_how__OlCv3","banner":"Embsample_banner__+AaUC"};